import React from "react";
import { defineMessages } from "react-intl";
import { Section } from "react-native-responsive-layout";
import { withTheme } from "styled-components/native";
import { string as yupString, object as yupObject, array as yupArray } from "yup";
import { FormGeneralStatusField } from "cci-admin";
import { DeletableItem, FormCell, FormTextField, FormEmailField, FormSelectValueField, FormToManyField, Container, Icon, Button } from "cci-component";
import {
  findOfficeByIdQuery,
  saveOfficeMutation,
  deleteOfficeMutation
} from "cci-data";
import MutableInspect from "../../inspect/MutableInspect";
import { InspectSubtitle } from "../../layout/Titles";

const messages = defineMessages({
  office: {
    id: "office",
    defaultMessage: "Office"
  },

  alias: {
    id: "alias",
    defaultMessage: "Alias"
  },

  firstName: {
    id: "firstName",
    defaultMessage: "First Name"
  },

  lastName: {
    id: "lastName",
    defaultMessage: "Last Name"
  },

  emails: {
    id: "emails",
    defaultMessage: "E-mails"
  },
});

/**
 * Inspect component for the Office entity, allows the user to create, edit or delete records if they have permission to do so.
 */
const Inspect = ({ theme, ...restProps }) => (
  <MutableInspect
    title={messages.office}
    entityName="Office"

    query={findOfficeByIdQuery}
    queryName="findOfficeById"

    mutation={saveOfficeMutation}
    mutationName="saveOffice2"
    objectWrapper="office"
    defaultValues={{
      status: "active",
      contact: {
        type: "office"
      }
    }}
    validationSchema={yupObject().shape({
      contact: yupObject().shape({
        alias: yupString().required(),
        emails: yupArray().of(yupObject().shape({
          address: yupString().required().email("invalidEmailFieldError")
        }))
      })
    })}

    deleteMutation={deleteOfficeMutation}

    {...restProps}
  >
    {() => (
      <React.Fragment>
        <Section>
          {/* Alias */}
          <FormCell size="stretch">
            <FormTextField
              label={messages.alias}
              name="contact.alias"
            />
          </FormCell>

          {/* Status */}
          <FormCell xlSize={150}>
            <FormGeneralStatusField />
          </FormCell>
        </Section>

        <Section>
          {/* First Name */}
          <FormCell xlSize="1/2">
            <FormTextField
              label={messages.firstName}
              name="contact.firstName"
            />
          </FormCell>

          {/* Last Name */}
          <FormCell xlSize="1/2">
            <FormTextField
              label={messages.lastName}
              name="contact.lastName"
            />
          </FormCell>
        </Section>

        {/* E-mails */}
        <InspectSubtitle title={messages.emails} />

        <FormToManyField
          name="contact.emails"
          addValidation={yupObject().shape({
            address: yupString().required().email()
          })}
        >
          {({ name, isNew, push, remove }) => (
            <Container key={name} flexDirection="row" alignItems="center" paddings="10px">
              <DeletableItem allowDelete={!isNew} onPress={remove} checkPermissions={{ objects: "ContactEmail", actions: ["delete"] }}>
                {/* E-mail or add icon */}
                <Icon
                  iconSize={50}
                  color={theme.fontColor}
                  name={isNew ? "plus-circle" : "envelope"}
                />
              </DeletableItem>

              {/* E-mail address field */}
              <FormEmailField
                name={`${name}.address`}
                onBlur={push}
                margins="0 0 0 10px"
                width="230px"
              />
            </Container>
          )}
        </FormToManyField>
      </React.Fragment>
    )}
  </MutableInspect>
);

export default withTheme(Inspect);
